/* eslint-disable no-console */
import { useEffect, useRef } from "react"

export function Decoration({ map, decoration, show }) {
	const svgRef = useRef(null)
	useEffect(() => {
		return () => {
			svgRef.current.remove()
		}
	}, [])

	useEffect(() => {
		if (decoration) {
			let svg = decoration.svg
			let g = document.createElementNS("http://www.w3.org/2000/svg", "g")
			g.setAttributeNS(null, "viewBox", `${0} ${0}`)
			g.innerHTML = svg
			svgRef.current = g
			map.appendChild(g)
		}

		return () => {
			svgRef.current && svgRef.current.remove()
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [map])

	useEffect(() => {
		if (svgRef.current) {
			svgRef.current.style.display = show ? "block" : "none"

			if (decoration.decoration === "Restaurant") {
				console.log(decoration)
				console.log(show)
				console.log(svgRef.current.style.display)
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [show])

	return null
}
